import { render, staticRenderFns } from "./SocialButtons.vue?vue&type=template&id=5b4eb028&scoped=true&"
import script from "./SocialButtons.vue?vue&type=script&lang=ts&"
export * from "./SocialButtons.vue?vue&type=script&lang=ts&"
import style0 from "./SocialButtons.vue?vue&type=style&index=0&id=5b4eb028&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4eb028",
  null
  
)

export default component.exports